import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './style.css';

function Photos({ visible, beaconIndex }) {
  return (
    <div
      data-index={beaconIndex}
      className={classnames('section', 'photos', {
        'section--visible': visible,
      })}
    >
      <div
        /* BEACON */

        data-index={beaconIndex}
        className="beacon beacon--small"
      />
      <div className="fixed-content-wrapper">
        <h1 className="fade-in td1v section__header">
          <span>Smile. Laugh. Relive. </span>
          <br className="always" />
          <span>Remember.</span>
        </h1>
        <p className="fade-in td2 section__text">
          Memories.com is a space to celebrate the lives of loved ones, turn
          passing moments into lasting memories, and share stories of that loved
          one with family, friends or the world.
        </p>
      </div>
      <div
        /* BEACON */

        data-index={beaconIndex}
        className="beacon beacon--small beacon--bottom"
      />
    </div>
  );
}

Photos.propTypes = {
  visible: PropTypes.bool.isRequired,
  beaconIndex: PropTypes.number.isRequired,
};

export default Photos;
